import { render } from "./modalsReserveComponent.vue?vue&type=template&id=260e30aa"
import script from "./modalsReserveComponent.vue?vue&type=script&lang=js"
export * from "./modalsReserveComponent.vue?vue&type=script&lang=js"

import "./modalsReserveComponent.vue?vue&type=style&index=0&id=260e30aa&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__